<template>
  <div>
    <div class="t-panel-section">
      <p v-if="searching" class="t-search-message">Searching...</p>
      <p v-else class="t-search-message">
        Found {{ size }} result<span v-if="size !== 1">s</span> for &lsquo;{{
          terms
        }}&rsquo;
      </p>
    </div>

    <template v-if="pageNumResult">
      <div class="t-panel-section">
        <div class="t-panel-subheading">Page Number</div>
        <AppLink class="t-result-pagenum" :pageNum="pageNumResult.physical">
          Go to page {{ pageNumResult.logical }}
        </AppLink>
      </div>
    </template>

    <template v-if="results.length">
      <div class="t-panel-subheading">Search Results</div>
      <ul class="t-panel-list">
        <li v-for="(r, i) in results" :key="i" class="t-panel-item">
          <AppLink
            class="t-result-content"
            :pageNum="r.pageNum"
            :highlightText="terms"
          >
            <div class="t-result-text">
              <div
                class="t-result-title"
                v-for="(title, i) in titles[r.pageNum]"
                :key="i"
              >
                {{ title }}
              </div>
              <span class="t-result-snippet" v-html="r.snippetHtml"></span>
            </div>
            <span class="t-result-logical-pageno">{{ r.logicalPageNum }}</span>
          </AppLink>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import api from '../services/api'
import AppLink from './AppLink'

export default {
  name: 'SearchResults',

  props: {
    terms: {
      type: String,
      required: true,
    },
  },

  inject: ['pubInfo', 'logicalPages'],

  data() {
    return {
      searching: true,
      results: [],
      titles: {},
      size: 0,
    }
  },

  computed: {
    lowerLogicals() {
      return this.logicalPages.map(s => s.toLowerCase())
    },

    pageNumResult() {
      const idx = this.lowerLogicals.indexOf(this.terms.toLowerCase())
      return idx !== -1
        ? {
            logical: this.logicalPages[idx],
            physical: idx + 1,
          }
        : null
    },
  },

  created() {
    this.search()
  },

  watch: {
    terms() {
      this.search()
    },
  },

  methods: {
    search() {
      const terms = this.terms

      // show spinner
      this.searching = true

      // reset search results
      this.results = []
      this.titles = {}
      this.size = 0

      api
        .getSearchResults(this.pubInfo.tizraId, this.terms)
        .then(({results, size}) => {
          // protect race condition
          if (terms === this.terms) {
            this.size = size
            this.results = results
            this.searching = false
            this.addTitles()
          }
        })
        .catch(() => {
          // already sent to rollbar, just treat this as zero
          // results for now
          this.searching = false
        })
    },

    addTitles() {
      const results = this.results
      const pageNums = Array.from(new Set(results.map(r => r.pageNum))).sort()
      api
        .getOverlappingTitles(this.pubInfo.tizraId, pageNums)
        .then(r => {
          // protect race condition
          if (results === this.results) {
            this.titles = r
          }
        })
        .catch(() => {
          /* already sent to rollbar */
        })
    },
  },

  components: {AppLink},
}
</script>
